import styled from "styled-components";
import { darken, lighten } from 'polished';

const getColor = (color, mode) => {
  switch (mode) {
    case 'disabled':
      return darken(0.1, color);
    case 'hover':
      return lighten(0.4, color);
    default:
      return color;
  }
};
const getFontWeight = (fontSize, fontWeight) => {
  if (fontWeight != null) {
    return `
        font-weight: ${fontWeight};
        `;
  }
  const k = 700 / 17; // 基准比例系数
  return `
    font-weight: ${Math.round(k * fontSize)};
    `;
};
const getFontStyles = (size) => {
  const sizeInRem = size / 16;
  return `
                font-size: ${sizeInRem}rem;
                line-height: ${(sizeInRem * 1.2)}rem;
                letter-spacing: 0.2px;
            `;
};

export const BTN1 = styled.button`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 9px;
    border: 1px solid #454545;
    border-radius: 999px;
    cursor: pointer;
`;

export const BTN2 = styled.button`
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 9px 66px;
gap: 10px;
background: #FFFFFF;
border-radius: 10px;
border-width:0px;
cursor: pointer;
`;

export const BTN3 = styled.button.withConfig({
  shouldForwardProp: (prop) => !['disableBg', 'normalBg', 'normalColor', 'disableColor', 'hoverBg', 'hoverColor'].includes(prop),
})`
    box-sizing: border-box;
    white-space: nowrap;
    cursor: pointer;
    background: ${props => props.normalBg || '#000000'};
    color: ${props => props.normalColor || '#FFFFFF'};
    border: 1px solid black;
    &:disabled,
    &:disabled:hover {
        background: ${props => props.disableBg || getColor(props.normalBg || '#D9D9D9', 'disabled')};
        border: 1px solid #e6e2e2;
        color: ${props => props.disableColor || getColor(props.normalColor || '#515050', 'disabled')};
    }
    &:hover {
        background: ${props => props.hoverBg || getColor(props.normalBg || '#FFFFFF', 'hover')};
        border-color:${props => props.hoverBg || getColor(props.normalBg || '#FFFFFF', 'hover')};
        color: ${props => props.hoverColor || getColor(props.normalColor || '#000000', 'hover')};
    }
`;



export const BTN4 = styled.button`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background: #000;
      border-radius: 99px;
      border-width:0px;
      cursor: pointer;
`;

export const BTN5 = styled.button`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background: #EEEEEE;
      border-radius: 40px;
      border-width:0px;
      padding:.6rem 1rem;
      cursor: pointer;
`;

export const BTN6 = styled.button`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background: #7C7C7C;
      border-radius: 6px;
      border-width:0px;
      padding:.6rem 1rem;
      cursor: pointer;
      white-space:nowrap;
`;
export const BTN_CIRCLE_1 = styled.button.withConfig({
  shouldForwardProp: (prop) => !['borderRadiusStyle'].includes(prop),
})`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    background: rgba(118, 118, 128, 0.24);
    backdrop-filter: blur(10px);
    background-blend-mode: normal, color-dodge, lighten;
    color: '#FFFFFF';
    width: ${props => props.w || '1rem'};
    height: ${props => props.h || '1rem'};
    border-width: 0px;
    ${props => {
    switch (props.borderRadiusStyle) {
      case 'top':
        return `
                    border-top-left-radius: 99px;
                    border-top-right-radius: 99px;
                `;
      case 'bottom':
        return `
                    border-bottom-left-radius: 99px;
                    border-bottom-right-radius: 99px;
                `;
      default:
        return `
                    border-top-left-radius: 99px;
                    border-top-right-radius: 99px;
                    border-bottom-left-radius: 99px;
                    border-bottom-right-radius: 99px;
                `;
    }
  }}

   

    > img {
        object-fit: contain;
        width: 50%;
        height: 50%;
    }
    ${props =>
    props.active &&
    `
          background: #FFFFFF;
      `}

      &:disabled,
    &:disabled:hover {
        background: linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(94, 94, 94, 0.18), rgba(94, 94, 94, 0.18)), rgba(255, 255, 255, 0.06);
        background-blend-mode: normal, color-dodge, lighten;
        backdrop-filter: blur(10px);
    }
    
    &:hover {
        ${props =>
    props.active
      ? `background: #FFFFFF;`
      : `background: ${getColor("#7676803D", 'hover')};
                `}
      background-blend-mode: normal, color-dodge, lighten;
      backdrop-filter: blur(10px);
    }
`;

export const BackgroundColor = styled.div`
    &{
        background: ${props => props.color || '#FFF'};
    `;

export const BackgroundDiv = styled.div`
    &{
        background-image:url('${props => props.img}');
        background-size: ${props => props.size || 'cover'};
        background-repeat: no-repeat;
        background-position: center center;
    `;
    export const InviteBg = styled.div`
    background-image: url('${props => props.img}');
    background-size: ${props => props.size || 'cover'};
    background-repeat: no-repeat;
    background-position: center center;
    width: ${props => props.width || '84%'};
    aspect-ratio: 393/500;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    position:relative;
`;

export const StyledTextarea = styled.textarea`
position: absolute;
  margin-top: ${({ marginTop }) => marginTop || "4rem"};
  height: ${({ height }) => height || "20rem"};
  max-height: ${({ height }) => height || "20rem"};
  line-height: ${({ lineHeight }) => lineHeight || "1.8rem"};
  text-align: center;
  box-sizing: border-box;
  width: calc(${({ width }) => width || "60%"});
  min-width: calc(${({ width }) => width || "60%"});
  aspect-ratio: 360 / 150;
  background: rgba(255, 255, 255, 0);
  color: #AB9B14;
  border: 0px;
  resize: none;
  font-size: 1rem;
  outline: none;
  white-space: pre-wrap;
`;
export const BackgroundLabel = styled.label`
    &{
        background-image:url('${props => props.img}');
        background-size: ${props => props.size || 'cover'};
        background-repeat: no-repeat;
        background-position: center center;
    `;

export const Hr = styled.div`
    width: ${props => props.width || '100%'};
    height: 1px;
    background-color:${props => props.color || '#D9D9D9'} ;
    margin:${props => props.height || '0'} 0;
`;

export const Vr = styled.div`
    height: ${props => props.height || '100%'};
    width: 1px;
    background-color:${props => props.color || '#D9D9D9'} ;
`;

export const Input = styled.input`
width:100%;
  border: 0;
  color: #333;
  font-family: ${props => props.fontFamily || "Noto Sans TC"}, sans-serif;
  font-style: normal;
  font-optical-sizing: auto;
  background: none;
  ${({ size }) => getFontStyles(size)}

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: none;
  }
`;
export const Label = styled.div`
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 16px;
box-sizing: border-box;
gap: 10px;
background: #FFFFFF;
border-radius: 10px;
position: relative;
`;

export const Span = styled.span`
  font-family: ${props => props.fontFamily || "Noto Sans TC"}, sans-serif;
  font-style: normal;
  font-optical-sizing: auto;
  ${({ color }) => color && `color: ${color};`}
  ${({ size }) => getFontStyles(size)}
  ${({ size, fontWeight }) => getFontWeight(size, fontWeight)}
`;
export const Select = styled.select`
  ${({ color }) => color && `color: ${color};`}
  ${({ fontSize }) => getFontStyles(fontSize)}
  ${({ fontSize, fontWeight }) => getFontWeight(fontSize, fontWeight)}
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.align || 'space-between'};
  align-items: center;
  width: 100%;
  gap: ${props => props.gap || '0'};
  box-sizing: border-box;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.align || 'flex-start'};
  width: 100%;
  gap: ${props => props.gap || '0'};
  box-sizing: border-box;
`;

export const VPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.align || 'space-between'};
  width: 100%;
  gap: ${props => props.gap || '0'};
  background: white;
  borderRadius: 1rem;
  padding:1rem;
box-sizing: border-box;
    border-radius: 1rem;
`;

export const RoundedDiv = styled.div`
    border-radius: ${props => props.radius || '1rem'};
    overflow: hidden;
`;